// eslint-disable-next-line no-use-before-define
import React from 'react';
import { SideMenuContainer } from './style';
import ReactDOM from 'react-dom';
import { SideMenuItem } from './item';
export const SideMenuComponent = ({ isOpen, menu, envLabel, hidden, }) => {
    if (!menu?.length) {
        return React.createElement(React.Fragment, null);
    }
    return ReactDOM.createPortal(React.createElement(SideMenuContainer, { envLabel: !!envLabel, className: `${isOpen && !hidden ? 'open' : 'closed'}` },
        React.createElement("div", { className: `auxiliary-menu` }, menu.map((item) => (React.createElement(SideMenuItem, { key: item.path, menuItem: item }))))), document.getElementById('root-app_side_content'));
};
//# sourceMappingURL=component.js.map